import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Box } from '@mui/material';

const SortingIconGroup = ({ sortingProps }) => {
	return (
		<Box sx={{ cursor: 'pointer', userSelect: 'none', ml: 1 }}>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				{sortingProps.isSorted ? (
					sortingProps.isSortedDesc ? (
						<>
							<CaretUpOutlined style={{ fontSize: '0.625rem', color: '#000000e0' }} />
							<CaretDownOutlined style={{ fontSize: '0.625rem', color: '#707070e0', marginTop: '-2px' }} />
						</>
					) : (
						<>
							<CaretUpOutlined style={{ fontSize: '0.625rem', color: '#707070e0' }} />
							<CaretDownOutlined style={{ fontSize: '0.625rem', color: '#000000e0', marginTop: '-2px' }} />
						</>
					)
				) : (
					<>
						<CaretUpOutlined style={{ fontSize: '0.625rem', color: '#707070e0', marginTop: '-2px' }} />
						<CaretDownOutlined style={{ fontSize: '0.625rem', color: '#707070e0', marginTop: '-2px' }} />
					</>
				)}
			</Box>
		</Box>
	);
};

export const TanStackColumnSorting = ({ header, color }) => {
	return (
		<Box sx={{ cursor: 'pointer', userSelect: 'none', ml: 1 }} onClick={header.column.getToggleSortingHandler()}>
			<Box sx={{ display: 'flex', flexDirection: 'column' }}>
				{(() => {
					switch (header.column.getIsSorted()) {
						case 'asc':
							return (
								<>
									<CaretUpOutlined style={{ fontSize: '0.625rem', color: '#000000e0' }} />
									<CaretDownOutlined style={{ fontSize: '0.625rem', color: color ?? '#707070e0', marginTop: '-2px' }} />
								</>
							);
						case 'desc':
							return (
								<>
									<CaretUpOutlined style={{ fontSize: '0.625rem', color: color ?? '#707070e0' }} />
									<CaretDownOutlined style={{ fontSize: '0.625rem', color: '#000000e0', marginTop: '-2px' }} />
								</>
							);
						default:
							return (
								<>
									<CaretUpOutlined style={{ fontSize: '0.625rem', color: color ?? '#707070e0', marginTop: '-2px' }} />
									<CaretDownOutlined style={{ fontSize: '0.625rem', color: color ?? '#707070e0', marginTop: '-2px' }} />
								</>
							);
					}
				})()}
			</Box>
		</Box>
	);
};

export default SortingIconGroup;
